export function Pintrest() {
  return (
    <span className="anticon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Layer_1"
        data-name="Layer 1"
        viewBox="0 0 64 64"
        width="64"
        height="64"
      >
        <title>{'icon-pi'}</title>
        <path
          d="M0,57.33V6.66A6.69,6.69,0,0,1,6.67,0H57.35A6.69,6.69,0,0,1,64,6.66V57.33A6.69,6.69,0,0,1,57.35,64H6.67A6.69,6.69,0,0,1,0,57.33Zm22.15-.54a1.17,1.17,0,0,0,.93-.49,25.48,25.48,0,0,0,4.36-8c.19-.68,1.39-4.17,2.28-6.72a8.31,8.31,0,0,0,5.49,2.11c7.85,0,13.55-7.14,13.55-17,0-7-5.89-14.33-15.75-14.33-11.07,0-17.68,7.91-17.68,15.56,0,4.75,2,8.4,5.33,9.77a1.93,1.93,0,0,0,.71.14,1.58,1.58,0,0,0,1.55-1.27l.48-1.9a2.67,2.67,0,0,0,.1-.69,2,2,0,0,0-.6-1.35,6,6,0,0,1-1.37-4.12A10.45,10.45,0,0,1,32.36,18c5.57,0,9,3.16,9,8.25,0,6.71-2.87,11.77-6.69,11.77a3.08,3.08,0,0,1-2.46-1.12,2.7,2.7,0,0,1-.58-1.7,3.27,3.27,0,0,1,.09-.75c.25-1.06.59-2.16.92-3.22a20.2,20.2,0,0,0,1.19-5.34c0-2.6-1.6-4.35-4-4.35-3,0-5.36,3-5.36,6.92a10.35,10.35,0,0,0,.7,3.79c-.56,1.91-3.66,12.51-4.08,14.29A19.74,19.74,0,0,0,20.68,51a33.83,33.83,0,0,0,.37,4.81,1.1,1.1,0,0,0,1.1,1Z"
          fill="currentcolor"
        />
      </svg>
    </span>
  );
}
